import listComponent from '@/util/proto/listComponent'

const type = [
  {value:0 , label:'限时预警'},
  {value:1 , label:'超时预警'},
]
export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          align:'center',
          width: 60,
        },
        {
          title: '姓名',
          key: 'name',
          width: 120,
        },
        {
          title: '身份证',
          key: 'idcard',
          minWidth: 100,
          // sortable:true,
        },
        {
          title: '联系电话',
          key: 'phone',
          minWidth: 120,
        },
        {
          title: '违法次数',
          key: 'actNum',
          minWidth: 100,
        },
        {
          title: '证照总分',
          key: 'scoreTotal',
          minWidth: 100,
        },
        {
          title: '已扣分数',
          key: 'scoreAct',
          minWidth: 100,
        },
        {
          title: '剩余分数',
          key: 'scoreLast',
          minWidth: 100,
        },
      ],
      data: [],
      options:{},
      visible:false,
    }
  },


  methods: {

    init(options) {
      this.options = options
      this.visible = true
      this.search()
    },
    search(){

      let params = { search:this.options || {}, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true

      this.$request.statsCourierLicense(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list || [] , { 'eventTime':'datetime' , type})
        this.page.total = resp.data.total
      })
    },
  },

  render(){
    const data = this.data || {}

    const title = '违法信息'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />

      </sl-side-panel>
    )
  }
}
